import { Mui, MuiLab } from "@osu/react-ui";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSystemAlert } from "../../actions-index";
import { forwardRef } from "react";

const selectAlert = (state) => {
  const { heading = "", description = "", severity } = state?.alert || {};
  return {
    heading,
    description,
    severity: severity || "info",
  };
};

const useStyles = Mui.makeStyles((theme) => {
  return {
    alert: {
      marginBottom: theme.spacing(3),
      padding: theme.spacing(2),
    },
    title: {
      color: 'inherit'
    },
  };
});

const PaperAlert = forwardRef((props, ref) => {
    return <Mui.Paper component={MuiLab.Alert} {...props} ref={ref} />;
})

function SystemAlert() {
  const {
    heading = "",
    description = "",
    severity = "info",
  } = useSelector(selectAlert);
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {
    dispatch(getSystemAlert());
    //dispatch is stable, only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const props = {};

  if (description || heading) {
    props.severity = severity || "info";
    props.component = PaperAlert;
    props.elevation = 4;
    props.className = classes.alert;
  }

  return (
    <Mui.Box role="alert" aria-live="polite" {...props}>
      {heading && <MuiLab.AlertTitle className={classes.title}>{heading}</MuiLab.AlertTitle>}
      {description && description}
    </Mui.Box>
  );
}

export default SystemAlert;
